import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { PENETAPAN_PEGAWAI_PREDIKAT_RATING_OPTIONS } from 'app/KinerjaTimPenilaiPSPage/constants/penetapan'

import type { PenetapanPredikatKinerjaRating } from 'types/kinerja-ps-pegawai'

type LabelPredikatKinerjaProps = {
  value: PenetapanPredikatKinerjaRating
  variant?: 'text' | 'badge'
}

type ColorSpecs = { foreground: string; background: string; border?: string }

const COLORS: Record<PenetapanPredikatKinerjaRating, ColorSpecs> = {
  VERY_GOOD: {
    foreground: '!text-default',
    background: '!bg-green-10',
  },
  GOOD: {
    foreground: '!text-default',
    background: '!bg-green-5',
  },
  NEED_IMPROVEMENT: {
    foreground: '!text-default',
    background: '!bg-orange-5',
  },
  BAD: {
    foreground: '!text-default',
    background: '!bg-red-5',
  },
  VERY_BAD: {
    foreground: '!text-default',
    background: '!bg-red-10',
  },
  NOT_SET: {
    foreground: '!text-subdued',
    background: 'bg-gray-10',
  },
}

const DEFAULT_COLORS: ColorSpecs = {
  foreground: '!text-subdued',
  background: 'bg-gray-10',
}

export function LabelPredikatKinerja({ value }: LabelPredikatKinerjaProps) {
  const label = PENETAPAN_PEGAWAI_PREDIKAT_RATING_OPTIONS[value]
  const colors = COLORS[value] ?? DEFAULT_COLORS

  return (
    <div
      className={clsx([
        'px-6 py-4',
        'rounded-lg border text-center',
        colors.border,
        colors.background,
      ])}
    >
      <Text variant="action" as="span" className={colors.foreground}>
        {label ??
          'Predikat akan muncul secara otomatis setelah semua Rating dipilih'}
      </Text>
    </div>
  )
}
